import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Router } from '@angular/router'

export type ButtonColor =
  | 'success'
  | 'info'
  | 'warning'
  | 'danger'
  | 'help'
  | 'primary'
  | 'secondary'
  | 'contrast'
  | null
  | undefined

export type ButtonSize = 'small' | 'medium' | 'large' | 'big' | 'xl' | undefined

@Component({
  selector: 'op-button-ng',
  templateUrl: './button-ng.component.html',
  styleUrls: ['./button-ng.component.scss'],
})
export class ButtonNgComponent implements OnInit {
  ngOnInit(): void {
    this.class =
      this.size === 'xl'
        ? 'button-xl'
        : this.size === 'big'
          ? 'button-big'
          : this.size === 'medium'
            ? 'button-medium'
            : this.size === 'small'
              ? 'button-small'
              : 'button-large'
  }

  @Input() buttonClass = ''
  @Input() label = ''
  @Input() icon?: string
  @Input() tooltipLabel?: string
  @Input() tooltipPosition: 'left' | 'top' | 'right' | 'bottom' = 'left'

  @Input() color: ButtonColor = 'primary'
  @Input() backgroundColor?: 'white' | 'black'
  @Input() outlined = false
  @Input() asText = false
  @Input() size: ButtonSize = 'small'
  @Input() height?: '4.5rem'
  @Input() fontSize?: '1.5rem' | '1.2rem'
  @Input() ghost = false
  @Input() square = false
  @Input() block = false

  @Input() disabled = false
  @Input() faded = false

  @Input() routerLink?: string
  @Input() fragment?: string
  @Input() target?: string

  @Output() readonly buttonClick = new EventEmitter<void>()

  constructor(private router: Router) {}

  public class = ''
  /**
   * Maps the component size to PrimeNG button size.
   * Since PrimeNG doesn't support 'medium', it maps to 'small'.
   */
  get pButtonSize(): 'small' | 'large' | undefined {
    if (this.size === 'medium' || this.size === 'small') {
      return 'small'
    }
    if (this.size === 'large' || this.size === 'big' || this.size === 'xl') {
      return 'large'
    }
    return undefined
  }

  routerLinkAction(event: MouseEvent) {
    event.preventDefault()
    event.stopPropagation()

    if (this.target) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(
          [this.routerLink],
          this.fragment ? { fragment: this.fragment } : {},
        ),
      )
      window.open(url, this.target, 'noopener,noreferrer')
    } else {
      const urlTree = this.router.createUrlTree(
        [this.routerLink],
        this.fragment ? { fragment: this.fragment } : {},
      )
      this.router.navigateByUrl(urlTree)
    }
  }
}
